import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Features from './components/Features';
import GamesAtmosphere from './components/GamesAtmosphere';
import DrinksBites from './components/DrinksBites';
import Events from './components/Events';
import PrivateParties from './components/PrivateParties';
import ContactLocation from './components/ContactLocation';
import Footer from './components/Footer';
import Navigation from './components/Navigation';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="bg-[#0a1628] text-white overflow-x-hidden">
      <Navigation scrolled={scrolled} />
      <Hero />
      <Features />
      <GamesAtmosphere />
      <DrinksBites />
      <Events />
      <PrivateParties />
      <ContactLocation />
      <Footer />
    </div>
  );
}
